// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

// Herko
export const environment = {
  production: false,
  Ambiente: 1,
  Id_Application: 5,
  appName: 'Conta-E',
  appVersion: '3.8.6',
  AppToken: 'F0BD2798-C8DD-4D0E-8B33-3C76A5ADB487',
  LoginURL: "https://apps.ximplify.mx/"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts